<template>

  <div class="example-btn">
    <file-upload
      ref="upload"
      v-model="files"
      class="btn btn-sm btn-outline-primary"
      post-action="/upload/post"
      :multiple="true"
      :size="maxSize"
      :drop="true"
      :drop-directory="true"
      @input="salvaNaNuvem"
    >
      <font-awesome-icon
        :icon="faFolderPlus"
        class="text-secondary mr-50"
        style="font-size:1rem !important; color:#c1af1d !important;"
        color="red"
      />
      Carregar arquivos em lote
    </file-upload>
  </div>
</template>

<style lang="scss">
.example-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFolderPlus,
} from '@fortawesome/free-solid-svg-icons'
import FileUpload from 'vue-upload-component'
import api from '../../services/api'
import { enviarNuvem } from '@/shared/mixins/upload-wasabi/upload-wasabi'
import mixins from '@/shared/mixins/upload/Upload.vue'

export default {
  components: {
    FontAwesomeIcon,
    FileUpload,
  },
  mixins: [mixins],
  data() {
    return {
      faFolderPlus,
      files: [],
      testes: [],
      maxSize: 536870912, // 512mb
    }
  },
  computed: {
    ...mapGetters('empresaExGlobal', ['empresa']),
    ...mapGetters('uploadLote', ['arquivos']),

  },
  methods: {
    ...mapActions('uploadLote', ['setArquivos', 'addAquivoList', 'concat_lists']),
    inputFilter(newFile, oldFile, prevent) {
      const file = newFile
      if (file && !oldFile) {
        if (this.isDangerFile(file.name)) {
          this.$erro('Arquivos não permitidos')
          return prevent()
        }

        if (!this.allowExtension(file.name, this.extensions)) {
          this.$warning(`Apenas arquivos ${this.extensions} são permitidos`)
          return prevent()
        }
      }

      if (file && (!oldFile || file.file !== oldFile.file)) {
        file.url = ''
        const URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          file.url = URL.createObjectURL(file.file)
        }
      }
      return null
    },
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.active && !oldFile.active && this.maxSize) {
          if (this.invalidFileSize(this.maxSize, newFile.size)) {
            this.$refs.upload.update(newFile, { error: 'Tamanho inválido' })
          }
        }

        if (newFile.error && !oldFile.error) {
          this.$erro(`Não foi possível salvar o arquivo ${newFile.name}. ${newFile.error}`)
          this.$refs.upload.remove(newFile)
        }
      }
    },
    getFormDataBody() {
      const newArquivos = this.files.filter(e => e.size < this.maxSize && !this.isDangerFile(e.name)).map(map => {
        const file = {
          nomeArquivo: map.name,
          loading: true,
          indetificado: map.id,
        }
        return file
      })
      if (this.arquivos.length > 0) {
        this.concat_lists(newArquivos)
      } else {
        this.setArquivos(newArquivos)
      }
      const formsData = []
      this.files.forEach(file => {
        const formData = new window.FormData()
        if (this.isDangerFile(file.name)) {
          this.$erro(`O arquivo ${file.name} não é permitido`)
        } else if (file && file.size < this.maxSize) {
          formData.append('file', file.file, file.filename || file.name)
          formData.append('identificador', file.id)
          formsData.push(formData)
        } else {
          this.$erro(`O arquivo ${file.name} excedeu o limite de 512mb`)
        }
      })

      return formsData
    },
    salvaNaNuvem() {
      const formsData = this.getFormDataBody()
      const arquivoEmLote = {
        empresaId: this.empresa.id,
        guidArquivo: '',
        nomeArquivo: '',
      }
      const newArquivos = []
      if (formsData.length > 0) {
        formsData.forEach(arquivo => {
          api.getDadosParaSalvarStorage(this.empresa.id, arquivo.get('file').name)
            .then(response => {
              arquivoEmLote.arquivoNovo = response.data.arquivoNovo
              enviarNuvem(arquivoEmLote.arquivoNovo, arquivo.get('file'), response.data.storage)
                .then(promisse => {
                  if (promisse && promisse.sucesso) {
                    const guid = response.data.arquivoNovo.split('/')[2]
                    arquivoEmLote.guidArquivo = guid
                    arquivoEmLote.nomeArquivo = arquivo.get('file').name
                    api.salvarArquivoCarregadoEmLote(arquivoEmLote)
                      .then(payload => {
                        newArquivos.push(payload.data)
                        const resp = payload.data
                        resp.indetificado = arquivo.get('identificador')
                        this.addAquivoList(resp)
                      })
                  }
                })
            })
        })
        this.$emit('setNewList', newArquivos)
        this.files = []
      }
    },
  },
}
</script>
